import React from "react";
import { SafTextField } from "@saffron/core-components/react";

const SafTextComp = ({ errors, label, name, value, onBlur, onChange }) => {
  return (
    <SafTextField
      // invalid={!valid}
      invalid={!!errors}
      label={label}
      name={name}
      value={value}
      validationMessage={errors}
      tabIndex={0}
      type="text"
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};

export default SafTextComp;
